import { type FC } from "react";
import { useTranslation } from "@privacy/translations";
import { useForm } from "react-hook-form";
import * as FormDialog from "../../shared/FormDialog";
import type { DpiaById } from "../../api/dpia.types";
import { updateDpiaMutationOptions } from "../../api/dpia";
import { useMutation } from "@tanstack/react-query";

type DpiaEditDialogProps = {
  onClose: () => void;
  dpia: DpiaById;
};

export const DpiaEditDialog: FC<DpiaEditDialogProps> = ({ onClose, dpia }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setFocus } = useForm<{ name: string }>({
    defaultValues: { name: dpia.name },
  });
  const updateDpiaMutation = useMutation(updateDpiaMutationOptions());

  FormDialog.useAutoFocusField(setFocus, "name");

  const handleUpdateDpia = (payload: { name: string }) => {
    updateDpiaMutation.mutate({ id: dpia.id, payload }, { onSuccess: onClose });
  };

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("DpiaDrawer.Edit.DialogHeader")}</FormDialog.Title>

      <FormDialog.Form onSubmit={handleSubmit(handleUpdateDpia)}>
        <FormDialog.Content>
          <FormDialog.FormError isError={updateDpiaMutation.isError} />
          <FormDialog.Fields>
            <FormDialog.TextField
              control={control}
              name="name"
              rules={{ required: t("DpiaDrawer.Edit.Error") }}
              label={t("DpiaDrawer.Edit.NameLabel")}
              placeholder={t("CreateDpia.Dialog.NamePlaceholder")}
            />
          </FormDialog.Fields>
        </FormDialog.Content>

        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onClose} />
          <FormDialog.SubmitButton isSubmitting={updateDpiaMutation.isPending}>
            {t("DpiaDrawer.Edit.SubmitButton")}
          </FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
